import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import globalSlice from "./slices/globalSlice";
import adminSlice from "./slices/adminSlice";
import studentSlice from "./slices/studentSlice";
import chatSlice from "./slices/chatSlice";
import mentorshipSlice from "./slices/mentorshipSlice";
import mentorshipManagementSlice from "./slices/mentorshipManagementSlice";
import accountsSlice from "./slices/accountsSlice";
import whatsappChatSlice from "./slices/whatsappChatSlice"
import currencySlice from './slices/currencySlice'
import aiAbstractSubmissionSlice from "./slices/aiAbstractSubmissionSlice"

const store = configureStore({
  reducer: {
    auth: authSlice,
    global: globalSlice,
    admin: adminSlice,
    student: studentSlice,
    chat: chatSlice,
    mentorship: mentorshipSlice,
    mentorshipManagement: mentorshipManagementSlice,
    accounts: accountsSlice,
    whatsappChat: whatsappChatSlice,
    currency: currencySlice,
    aiAbstractSubmission: aiAbstractSubmissionSlice
  },
});

export default store;
